module.exports = __webpack_public_path__ + "static/media/7g_website_logo_Gold_sc.ed6e8cd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/7g_website_logo_Gold_sc.jpg
// module id = 115
// module chunks = 0